import * as css from './ProfileCard.css';
import {roleArr} from '../../../team/memberRoleBtn/MemberRoleBtn';
import {isMaster} from '../../../../functions/permission';
import {useSelector} from 'react-redux';
import {useTranslation} from 'react-i18next';

export function ProfileCard({openProfile}) {
    const event = useSelector((s: any) => s.event);
    const user = useSelector((s: any) => s.user);
    const account = useSelector((s: any) => s.account);
    const {t} = useTranslation('realtime');
    const role = (!isMaster() && event.userEventRole) || account.userAccountRole;

    return (
        <css.profile data-cy="profile">
                <css.edit data-cy="editProfile" onClick={openProfile}/>
            <css.content>
                <css.profileImage image={user.picture}/>
                <css.userName>{user.nameFirst} {user.nameLast}</css.userName>
                <css.roleLabel data-cy="profileRole">
                    <css.roleIcon $icon={roleArr[role]?.icon}/>
                    {t(role)}
                </css.roleLabel>
            </css.content>
        </css.profile>
    );
}
